import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialCard from "./components/testimonial_card";
import styles from "./testimonial.module.scss";

export const TestimonialSection = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    centerMode: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section className={styles.section_testimonial}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2 className={`${styles.title} center`}>Testimonials</h2>
          <p className={`${styles.sub_title} font-xlarge center`}>
            What Our University Partners Say About Us
          </p>
          <div className="testimonial_wrapper">
            <Slider {...settings}>
              <TestimonialCard />
              <TestimonialCard />
              <TestimonialCard />
              <TestimonialCard />
              <TestimonialCard />
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
